var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "content-wrapper" },
        [
          _vm.currentTemplate
            ? _c("HeaderMain", {
                ref: "header",
                attrs: { headerType: _vm.currentTemplate },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_vm.currentTemplate, { tag: "component" }, [_c("router-view")], 1),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.toast.active
            ? _c("InfoToast", {
                attrs: { type: _vm.toast.type, text: _vm.toast.text },
                on: { alertClose: _vm.alertClose },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }